export enum HostingType {
  PAAS = 'PaaS',
  IAAS = 'IaaS',
  SAAS = 'SaaS/Cloud Based',
  ON_PREMISE = 'On-premise',
  EXTERNAL_HOSTING = 'External Hosting',
}
